import React, {useCallback} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Logo from '../../../../assets/images/logos/logo_white_horz_full.png';
import background_image from '../../../../assets/images/onboarding/welcome_modal_background.png';

interface AppTourWelcomeModalProps {
  open: boolean;
  onStart: () => void;
  onSkip: () => void;
  startButtonLabel?: string;
  title?: React.ReactNode;
  description?: string;
}

const AppTourWelcomeModal: React.FC<AppTourWelcomeModalProps> = ({open, onStart, onSkip, startButtonLabel, title, description}) => {
  const handleClose = useCallback(
    (_event: object, reason: string) => {
      if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
        onSkip();
      }
    },
    [onSkip]
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="welcome-title"
      aria-describedby="welcome-description"
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: {xs: 1, sm: 2, md: 3},
          boxShadow: {xs: 2, sm: 4, md: 8},
          width: {xs: '70vw', sm: 450, md: 480},
          minHeight: {xs: '50vh', sm: 450, md: 550},
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: `url(${background_image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }
      }}
    >
      <DialogContent
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        <Box 
        sx={{
          width: '100%', 
          display: 'flex', 
          justifyContent: 'center',
          mt: {xs: '8px', sm: '10px', md: '15px'},
          mb: {xs: '20px', sm: '30px', md: '33px'}
        }}>
          <img
            src={Logo}
            alt="Priwall logo"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
            style={{
              width: "260px", 
              height: "65px"
            }}
          />
        </Box>

        <Typography
          id="welcome-title"
          variant="inherit"
          sx={{
            fontWeight: 500,
            fontSize: {xs: 20, sm: 25, md: 30},
            color: '#FFFFFF',
            lineHeight: {xs: '25px', sm: '30px', md: '35px'},
            textAlign: 'center',
            width: '545px',
            marginBottom: {xs: '10px', sm: '12px', md: '30px'},
          }}
        >
         {title}
        </Typography>

        <Typography
          id="welcome-description"
          variant="inherit"
          sx={{
            fontSize: {xs: 16, sm: 17, md: 18},
            color: '#F3F3F3',
            fontWeight: 500,
            fontFamily: 'InterMedium',
            lineHeight: {xs: '18px', sm: '20px', md: '25px'},
            textAlign: 'center',
            width: {xs: '100%', sm: '95%', md: '95%'},
            marginBottom: {xs: '25px', sm: '30px', md: '40px'},
          }}
        >
         {description}
        </Typography>

        <Typography
          component="button"
          sx={{
            background: '#9035DE',
            color: '#fff',
            borderRadius: {xs: 1},
            fontWeight: 500,
            fontSize: {xs: 10, sm:14, md: 16},
            width: {sx: '175px', sm: '200px', md: '250px'},
            border: 'none',
            height: {xs:'35px', sm: '40px', md: '55px'},
            marginBottom: {xs:'15px', sm: '20px', md: '20px'},
            lineHeight: { xs:'20px', sm: '25px', md: '30px'},
            display: 'block',
            '&:hover': {
              background: '#7C3AED',
              color: '#fff',
              boxShadow: 4,
              cursor: 'pointer',
            }
          }}
          onClick={onStart}
        >
          {startButtonLabel}
        </Typography>

        <Typography
          component="button"
          onClick={onSkip}
          sx={{
            color: '#717EB9',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: {xs: 12, sm:16, md: 16},
            fontWeight: 500,
            p: 0,
            transition: 'color 0.2s',
            '&:hover': {color: '#fff'},
            display: 'block',
            mx: 'auto',
          }}
        >
          Skip the tour
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(AppTourWelcomeModal);